import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";
import {IContrato} from "@models/contratos/contrato.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {ICreateContratoDto} from "@components/contratos/models/ICreateContratoDto.ts";
import {IContratoParcela} from "@models/contratos/parcelamento.ts";
import {ICreateContratoParcelaDto} from "@components/contratos/models/ICreateContratoParcelaDto.ts";
import {IContratoDetalhes} from "@components/contratos/models/IContratoDetalhes.ts";

export const __contrato_endpoints = {
    v2: {
        ['create-contrato']: (data: IDataNoPageDto<ICreateContratoDto>) => {
            return {
                url: `/api/v2/contratos`,
                data: data,
                method: 'POST'
            } as IApiEndpoint<IContrato>
        },
        ['undraft-contrato']: (data: IDataNoPageDto<{ idContrato: number }>) => {
            const {idContrato, ...rest} = data.data
            return {
                url: `/api/v2/contratos/${idContrato}/undraft`,
                data: {...data, data: {...rest}},
                method: 'POST'
            } as IApiEndpoint<IContrato>
        },
        ['update-contrato']: (data: IDataNoPageDto<Partial<ICreateContratoDto> & {
            idContrato: number,
            isUsaDiferimento?: boolean,
            isTerminoIndefinido?: boolean,
        }>) => {
            const {idContrato, ...rest} = data.data

            return {
                url: `/api/v2/contratos/${idContrato}`,
                data: {...data, data: {...rest}},
                method: 'PATCH'
            } as IApiEndpoint<IContrato> as IApiEndpoint<IContrato>
        },
        ['get-parcelas']: (data: IDataDto<{ idContrato: number }>) => {
            const {idContrato, ...rest} = data.data

            return {
                url: `/api/v2/contratos/${idContrato}/parcelas`,
                data: {...data, data: {...rest}},
                method: 'GET'
            } as IApiEndpoint<IContratoParcela[]>
        },
        ['get-contrato-by-id']: (data: IDataNoPageDto<{ idContrato: number }>) => {
            const {idContrato, ...rest} = data.data

            return {
                url: `/api/v2/contratos/${idContrato}`,
                data: {...data, data: {...rest}},
                method: 'GET'
            } as IApiEndpoint<IContrato>
        },
        ['get-parcela-by-id']: (data: IDataNoPageDto<{ idParcela: number }>) => {
            const {idParcela, ...rest} = data.data

            return {
                url: `/api/v2/contratos/parcelas/${idParcela}`,
                data: {...data, data: {...rest}},
                method: 'GET'
            } as IApiEndpoint<IContratoParcela>
        },
        ['get-contrato-detalhes-by-id']: (data: IDataNoPageDto<{ idContrato: number }>) => {
            const {idContrato, ...rest} = data.data

            return {
                url: `/api/v2/contratos/${idContrato}/detalhes`,
                data: {...data, data: {...rest}},
                method: 'GET'
            } as IApiEndpoint<IContratoDetalhes>
        },
        ['create-parcela']: (data: IDataNoPageDto<ICreateContratoParcelaDto>) => {
            const {idContrato, ...rest} = data.data
            return {
                url: `/api/v2/contratos/${idContrato}/parcelas`,
                data: {...data, data: {...rest}},
                method: 'POST'
            } as IApiEndpoint<IContratoParcela>
        },
        ['update-all-parcelas']: (data: IDataNoPageDto<{
            idContrato: number,
            remover: number[],
            atualizar: Partial<Omit<ICreateContratoParcelaDto, 'idContrato'> & { parcelaId: number }[]>,
        }>) => {
            const {idContrato, ...rest} = data.data


            return {
                url: `/api/v2/contratos/${idContrato}/parcelas`,
                data: {...data, data: {...rest}},
                method: 'PUT'
            } as IApiEndpoint<IContrato>
        }
    }
}